export default __webpack_public_path__ + "static/media/travelance-logo.58435e58.png";